// first digit is megabyte ...
// make sure this matched with the total file size in PHP and in the individual
// we multiply by 1000 rather than 1024 to ensure edge cases are caught!
// fields....
export const maxFileSize = 6 * 1024 * 1024;
